// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3LFEB","signatureBlock":"Footer_signatureBlock__1QxFj","signature":"Footer_signature__3Ue4B"};